import React from "react";
import {
  FaIdCard,
  FaLocationArrow,
  FaPersonBooth,
  FaPiggyBank,
  FaSubscript,
} from "react-icons/fa";
import logo from "../../../assets/IMGS/logo-long.png";
import { IoText } from "react-icons/io5";

const SetupProgress = ({ step }) => {
  return (
    <div className="setup-progress">
      <div className="setup-image-container">
        <img className="setup-progress-img" src={logo} alt="Setup Progress" />
      </div>

      <ul className="setup-progress-container">
        <li className="step">
          <IoText className={step === 1 ? "step-icon active" : "step-icon"} />
          <div className={step === 1 ? "step-details active" : "step-details"}>
            <h2>Choose a password</h2>
            <p>Choose a secure password</p>
          </div>
        </li>

        <li className="step">
          <FaLocationArrow
            className={step === 2 ? "step-icon active" : "step-icon"}
          />
          <div className={step === 2 ? "step-details active" : "step-details"}>
            <h2>Business Address</h2>
            <p>Please provide your Business Address</p>
          </div>
        </li>

        <li className="step">
          <FaPersonBooth
            className={
              step === 3 || step === 4 ? "step-icon active" : "step-icon"
            }
          />
          <div
            className={
              step === 3 || step === 4 ? "step-details active" : "step-details"
            }
          >
            <h2>Set up your store</h2>
            <p>Start collaborating with your team</p>
          </div>
        </li>

        <li className="step">
          <FaIdCard className={step === 5 ? "step-icon active" : "step-icon"} />
          <div className={step === 5 ? "step-details active" : "step-details"}>
            <h2>ID Verification</h2>
            <p>Verify your Identity</p>
          </div>
        </li>

        <li className="step">
          <FaPiggyBank
            className={step === 6 ? "step-icon active" : "step-icon"}
          />
          <div className={step === 6 ? "step-details active" : "step-details"}>
            <h2>Subscriptions</h2>
            <p>Leverage Shophr's resources</p>
          </div>
        </li>
        <li className="step">
          <FaSubscript
            className={step === 7 ? "step-icon active" : "step-icon"}
          />
          <div className={step === 7 ? "step-details active" : "step-details"}>
            <h2>Link you bank account</h2>
            <p>Connect your bank to receive payouts</p>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default SetupProgress;
